import { organizationSectionEntityName, } from '../../../../../../backend/config/classifiers/OrganizationSectionClassifier/shared';
import { useStorageGet } from '@juvare/platform-sdk-react/ui/hooks';
export function useOrganizationSection(id) {
    return useStorageGet(organizationSectionEntityName, id);
}
